/* Progressive enhancement only. Shopify owns form submission and spam protection. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.initialized) return;
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      button.dataset.initialized = 'true';
      const close = () => { nav.classList.remove('is-open'); button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        nav.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
      });
      nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      button.closest('[data-header]').addEventListener('keydown', event => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') { close(); button.focus(); }
      });
    });
    const product = new URLSearchParams(window.location.search).get('product');
    if (product) root.querySelectorAll('[data-rfq-product]').forEach(input => {
      if (!input.value) input.value = product.slice(0, 300);
    });
    // Display errors and confirmation after Shopify's native response.
    const feedback = root.querySelector('[data-form-feedback]');
    if (feedback) feedback.focus({ preventScroll: false });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
